module.exports = __webpack_public_path__ + "img/商法.54547114.png";